import { FC } from 'react'
import { Modal } from '@lounge-fe/ui-kit'
import { ReviewsModalProps } from './types'
import { t } from 'i18next'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

const ReviewsModal: FC<ReviewsModalProps> = ({ children, trigger }) => {
  const { getFlag } = useFeatureFlags()
  const isProductReviewsV2Enabled = getFlag('enable_product_reviews_v2')

  if (isProductReviewsV2Enabled) {
    return (
      <Modal>
        <Modal.Trigger>{trigger}</Modal.Trigger>
        <Modal.Content
          size="2xl"
          isMobileFullscreen
          className="h-full sm:h-[670px] md:h-[600px]"
        >
          <Modal.CloseButton className="top-6 md:top-8 !right-6 md:!right-8" />
          <Modal.Body className="flex h-full flex-col overflow-hidden p-6 md:p-8">
            {children}
          </Modal.Body>
        </Modal.Content>
      </Modal>
    )
  } else {
    return (
      <Modal>
        <Modal.Trigger>{trigger}</Modal.Trigger>
        <Modal.Content size="lg">
          <Modal.Header>
            {t('general.reviews')}
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>{children}</Modal.Body>
        </Modal.Content>
      </Modal>
    )
  }
}

export { ReviewsModal }
